export default {
  header: {
    title: 'Osta lahjakortti',
  },
  checkout_btn: {
    title: 'Kassalle',
    max_quantity: 'Enintään {{max}} lahjakorttia per osto',
  },
  items: {
    gift_card: {
      online: 'Lahjakortti lunastettavissa vain verkossa',
      online_and_store: 'Lahjakortti (lunastettavissa verkossa ja ravintolassa)',
      title: 'Valitse haluamasi summa',
      description: 'Lisää lahjakortti haluamallasi määrällä koriin',
    },
    expiration: {
      label: 'Voimassa 3 vuotta',
      title: 'Nauti lahjan antamisesta!',
      description: 'Vastaanottaja voi lunastaa lahjakortin joustavasti 3 vuoden kuluessa.',
    },
    delivery: {
      label: 'Toimitus heti PDF-muodossa sähköpostitse',
      title: 'Välitön toimitus PDF-muodossa sähköpostitse',
      description: 'Turvallisen maksun jälkeen saat lahjakortin välittömästi.',
    },
  },
  form: {
    value: {
      title: 'Valitse lahjakortin summa',
      custom: {
        label: 'Mukautettu',
        placeholder: 'Syötä summa väliltä {{min}}–{{max}} {{currency}}',
      },
    },
    quantity: {
      title: 'Määrä',
    },
    email: {
      title: 'Mikä on sähköpostiosoitteesi, jotta voimme lähettää sinulle lahjakortin?',
      placeholder: 'Sähköpostiosoitteesi',
      error: 'Virheellinen sähköpostiosoite',
    },
  },
  confirmation: {
    title: {
      title: 'Osta lahjakortti?',
      subtitle_one: 'Haluatko ostaa 1 lahjakortin hintaan {{value}}?',
      subtitle_other: 'Haluatko ostaa {{count}} lahjakorttia hintaan {{value}}?',
    },
    description: {
      total: 'Yhteensä:',
      email: 'Sähköposti:',
      quantity: 'Määrä',
      amount: 'Summa',
    },
    footer: {
      cancel: 'Peruuta',
      confirm: 'Vahvista',
    },
  },
};
